import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Marca } from '../persistences/marca';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarcaService {

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) { }

  getMarcaById(cdMarca: number): Observable<Marca>{
    let httpParams = new HttpParams();
        httpParams = httpParams
            .append('id', cdMarca);
    return this.httpClient.get<Marca>(
      this.configService.getEndereco()+"/Marca/getById",
      {
        headers: this.configService.getHeaders(),
        params: httpParams
      }
    )
  }
}
